import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        site: {
            metaTitle: '',
            metaKeywords: '',
            metaDescription: '',
            ogImage: '',
        },

        uri: null,

        article: null,
        articles: [],

        post: null,
        posts: [],

        subscribe: false,
    },
    mutations: {
        site(state, payload) {
            state.site = payload;
        },
        uri(state, uri) {
            state.uri = uri;
        },
        articles(state, payload) {
            state.articles = payload;
        },
        article(state, payload) {
            state.article = payload;
        },
        posts(state, payload) {
            state.posts = payload;
        },
        post(state, payload) {
            state.post = payload;
        },
        subscribe(state, payload) {
            state.subscribe = payload;
        },
    },
    actions: {
        async loadSite(context) {
            try {
                let token = document.location.href.match(/\btoken=([^&]+)/);
                const url = token && token[1] ? '?token=' + token[1] : '';

                if (process.env.NODE_ENV == 'development') {
                    window.console.log('get site');
                }

                let site = {};
                const response = await axios({
                    method: 'post',
                    url: url,
                    data: {
                        query: `
                    query metadata { 
                      globalSets(site: "transparency") { ...on  seo_GlobalSet { 
                        metaTitle 
                        metaDescription 
                        metaKeywords 
                        ogImage {
                          url @transform (width: 1024, immediately: true)
                        }
                      } }
                    }
                  `,
                    },
                });
                if (typeof response.data.data.globalSets != 'undefined') {
                    for (const seo of response.data.data.globalSets) {
                        if (typeof seo.metaTitle != 'undefined') {
                            site = {
                                metaTitle: seo.metaTitle,
                                metaDescription: seo.metaDescription,
                                metaKeywords: seo.metaKeywords,
                                ogImage: seo.ogImage && seo.ogImage.length ? 'https://data.apenhet.no/' + seo.ogImage[0].url : null,
                            };
                            break;
                        }
                    }
                    context.commit('site', site);
                }
            } catch (e) {
                window.console.log(e);
            }
        },
        async loadArticles(context, uri /*, opts = {}*/) {
            try {
                let token = document.location.href.match(/\btoken=([^&]+)/);
                const url = token && token[1] ? '?token=' + token[1] : '';

                if (process.env.NODE_ENV == 'development') {
                    window.console.log('get articles' + (uri ? ' (' + uri + ')' : ''));
                }

                let query = '';

                if (uri) {
                    query = `entries(section:"transparencyArticle", site: "transparency", uri: "${uri}", limit: 1)`;
                }
                // default get all
                else {
                    query = `entries(section:"transparencyArticle", site: "transparency", orderBy: "postDate DESC")`;
                }

                const articles = [];
                const response = await axios({
                    method: 'post',
                    url: url,
                    data: {
                        query: `
                    query articles {
                      ${query} {
                        id
                        title
                        uri
                        postDate @formatDateTime (format: "d.m.Y")
                        ... on transparencyArticle_transparencyArticle_Entry {
                          transparencyLead
                          transparencyIssue
                          transparencyImage {
                            ... on transparencyImage_image_BlockType {
                              typeHandle
                              image  {
                                url @transform (width: 1024, height: 576, position: "center-center", immediately: true)
                              }
                            }
                            ... on transparencyImage_videoEmbed_BlockType {
                              typeHandle
                              image  {
                                url @transform (width: 1024, height: 576, position: "center-center", immediately: true)
                              } 
                              videoLink
                              videoFormat
                            }
                          }
                          transparencyArticleContent {
                            ... on transparencyArticleContent_column_BlockType {
                              heading
                              text
                            }
                          }
                          transparencyStatus {
                            uri
                          }

                          metaTitle 
                          metaDescription 
                          metaKeywords 
                          ogImage {
                            url @transform (width: 1024, immediately: true)
                          }                          
                        }
                      }
                    }
                  `,
                    },
                });

                if (typeof response.data.data.entries != 'undefined') {
                    for (const article of response.data.data.entries) {
                        article.lead = article.transparencyLead;
                        delete article.transparencyLead;

                        article.issue = article.transparencyIssue;
                        delete article.transparencyIssue;

                        article.uri = '/' + article.uri;

                        if (article.transparencyImage) {
                            if (article.transparencyImage[0].image) {
                                let image = Object.assign({}, article.transparencyImage[0]);
                                if (image.image.length) {
                                    image.url = 'https://data.apenhet.no/' + image.image[0].url;
                                    article.image = image;

                                    if (image.typeHandle == 'videoEmbed') {
                                        article.video = { link: image.videoLink, format: image.videoFormat || '16_9' };

                                        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                                        const match = article.video.link.match(regExp);
                                        if (match && match[7].length == 11) {
                                            article.video.youTubeId = match[7];
                                        }
                                    }
                                }
                            }
                            delete article.transparencyImage;
                        }
                        if (article.transparencyArticleContent) {
                            article.content = Object.assign({}, article.transparencyArticleContent);
                            delete article.transparencyArticleContent;
                        }

                        if (article.transparencyStatus) {
                            if (article.transparencyStatus.length && article.transparencyStatus[0].uri) {
                                article.statusUri = '/' + article.transparencyStatus[0].uri;
                            }
                            delete article.transparencyStatus;
                        }

                        if (article.ogImage.length && article.ogImage[0].url) {
                            let image = Object.assign({}, article.ogImage[0]);
                            article.ogImage = 'https://data.apenhet.no/' + image.url;
                        } else {
                            article.ogImage = null;
                        }

                        articles.push(Object.assign({}, article));
                    }
                    context.commit('articles', articles);

                    if (uri) {
                        context.commit('article', articles ? articles[0] : null);
                        context.commit('uri', uri);
                    } else {
                        context.commit('articles', articles);
                    }
                }
            } catch (e) {
                window.console.log(e);
            }
        },
        async loadPosts(context, uri) {
            try {
                let token = document.location.href.match(/\btoken=([^&]+)/);
                const url = token && token[1] ? '?token=' + token[1] : '';

                let opts = {};
                if (typeof uri == 'object') {
                    opts = uri;
                    uri = null;

                    if (process.env.NODE_ENV == 'development') {
                        window.console.log('get posts( ' + (JSON.stringify(opts) + ' )'));
                    }
                } else {
                    if (process.env.NODE_ENV == 'development') {
                        window.console.log('get posts' + (uri ? ' (' + uri + ')' : ''));
                    }
                }

                if (process.env.NODE_ENV == 'development') {
                    window.console.log('get posts' + (uri ? ' (' + uri + ')' : ''));
                    window.console.log(opts);
                }

                if (!opts.limit) {
                    opts.limit = 12;
                }
                if (!opts.offset) {
                    opts.offset = 0;
                }

                let query = '';

                // single post
                if (uri) {
                    query = `entries(section:"transparencyPost", site: "transparency", uri: "${uri}", limit: 1)`;
                }
                // relatedTo
                else if (opts.relatedTo) {
                    query = `entries(section:"transparencyPost", site: "transparency", relatedTo: ${opts.relatedTo}, limit: 3, orderBy: "postDate DESC")`;
                }
                // default is latest posts
                else {
                    query = `entries(section:"transparencyPost", site: "transparency", limit: ${opts.limit}, offset: ${opts.offset}, orderBy: "postDate DESC")`;
                }

                const posts = [];
                const response = await axios({
                    method: 'post',
                    url: url,
                    data: {
                        query: `
                    query blogposts {
                      ${query} {
                        title
                        uri
                        postDate @formatDateTime (format: "d.m.Y")
                        ... on transparencyPost_transparencyPost_Entry {
                          lead
                          transparencyImage {
                            ... on transparencyImage_image_BlockType {
                              image  {
                                url @transform (width: 1024, height: 576, position: "center-center", immediately: true)
                              }
                            }
                            ... on transparencyImage_videoEmbed_BlockType {
                              image  {
                                url @transform (width: 1024, height: 576, position: "center-center", immediately: true)
                              } 
                              videoLink
                              videoFormat
                            }
                          }
                          transparencyBlogBlocks {
                            ... on transparencyBlogBlocks_text_BlockType {
                             typeHandle
                              text
                            }
                            ... on transparencyBlogBlocks_heading_BlockType {
                             typeHandle
                              heading
                            }
                            ... on transparencyBlogBlocks_image_BlockType {
                             typeHandle
                              image {
                                url @transform (width: 1024 immediately: true)
                              }
                              caption
                            }
                            ... on transparencyBlogBlocks_video_BlockType {
                                typeHandle
                                videoLink
                               }
                            ... on transparencyBlogBlocks_embed_BlockType {
                                typeHandle
                                embed
                               }
                          }
                          transparencyAuthor {
                            ... on transparencyAuthor_author_BlockType {
                              fullName
                              organisation
                              image  {
                                url @transform (width: 512, height: 512, position: "center-center", immediately: true)
                              } 
                            }
                          }
                          transparencyArticles {
                            uri
                            ... on transparencyArticle_transparencyArticle_Entry {
                              transparencyColor
                              transparencyCategory
                            }
                          }

                          metaTitle 
                          metaDescription 
                          metaKeywords 
                          ogImage {
                            url @transform (width: 1024, immediately: true)
                          }
                        }
                      }
                    }`,
                    },
                });

                if (typeof response.data.data.entries != 'undefined') {
                    for (const post of response.data.data.entries) {
                        post.uri = '/' + post.uri;

                        if (post.transparencyImage) {
                            if (post.transparencyImage[0].image && post.transparencyImage[0].image.length) {
                                let image = Object.assign({}, post.transparencyImage[0]);
                                image.url = 'https://data.apenhet.no/' + image.image[0].url;
                                post.image = image;
                            }
                            delete post.transparencyImage;
                        }
                        if (post.transparencyBlogBlocks) {
                            let blocks = [];
                            for (const block of post.transparencyBlogBlocks) {
                                if (block.typeHandle == 'image') {
                                    if (block.image) {
                                        block.image = {
                                            url: 'https://data.apenhet.no/' + block.image[0].url,
                                            caption: block.caption,
                                        };
                                    }
                                }
                                blocks.push(block);
                            }
                            if (blocks) {
                                post.blocks = blocks;
                            }
                            delete post.transparencyBlogBlocks;
                        }
                        if (post.transparencyAuthor) {
                            if (post.transparencyAuthor.length && post.transparencyAuthor[0].fullName) {
                                let author = {
                                    name: post.transparencyAuthor[0].fullName,
                                    organisation: post.transparencyAuthor[0].organisation,
                                };
                                if (post.transparencyAuthor[0].image.length) {
                                    author.image = {
                                        url: 'https://data.apenhet.no/' + post.transparencyAuthor[0].image[0].url,
                                    };
                                }
                                post.author = author;
                            }
                            delete post.transparencyAuthor;
                        }
                        if (post.transparencyArticles.length) {
                            if (post.transparencyArticles[0].transparencyColor) {
                                post.category = {
                                    color: post.transparencyArticles[0].transparencyColor,
                                    name: post.transparencyArticles[0].transparencyCategory,
                                    uri: post.transparencyArticles[0].uri,
                                };
                            }
                            delete post.transparencyArticles;
                        }
                        if (post.transparencyArticles) {
                            post.category = post.transparencyCategory;
                            delete post.transparencyCategory;
                        }

                        if (post.ogImage.length && post.ogImage[0].url) {
                            let image = Object.assign({}, post.ogImage[0]);
                            post.ogImage = 'https://data.apenhet.no/' + image.url;
                        } else {
                            post.ogImage = null;
                        }

                        posts.push(post);
                    }

                    if (uri) {
                        context.commit('post', posts ? posts[0] : null);
                        context.commit('uri', uri);
                    } else {
                        if (opts.offset > 0) {
                            context.commit('posts', context.state.posts.concat(posts));
                        } else {
                            context.commit('posts', posts);
                        }
                    }
                }
            } catch (e) {
                window.console.log(e);
            }
        },
        async searchSite(context, query) {
            try {
                console.log(context);
                console.log(query);
                let token = document.location.href.match(/\btoken=([^&]+)/);
                const url = token && token[1] ? '?token=' + token[1] : '';

                const response = await axios({
                    method: 'post',
                    url: url,
                    data: {
                        query: `
                    query entries {
                      entries(section:["transparencyArticle", "transparencyPost"], site: "transparency", search: "${query}", orderBy: "score") {
                        title
                        uri
                        postDate @formatDateTime (format: "d.m.Y")
                        ... on transparencyArticle_transparencyArticle_Entry {
                            transparencyLead
                        }
                        ... on transparencyPost_transparencyPost_Entry {
                            lead
                        }                        
                      }
                    }`,
                    },
                });

                const entries = [];
                if (response && typeof response.data.data.entries != 'undefined') {
                    for (const entry of response.data.data.entries) {
                        entry.uri = '/' + entry.uri;
                        entry.lead = entry.lead || entry.transparencyLead || '';

                        entries.push(entry);
                    }
                    return entries;
                }
            } catch (e) {
                window.console.log(e);
            }
        },
        showSubscribe(context) {
            context.commit('subscribe', true);
        },
        hideSubscribe(context) {
            context.commit('subscribe', false);
        },
    },
    modules: {},
});
